import { Component, EventEmitter, Input, Output } from '@angular/core';
import {  faSquare } from '@fortawesome/free-regular-svg-icons';
import {  faCheckSquare } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'mayne-inline-checkbox',
  templateUrl: './inline-checkbox.component.html',
  styleUrls: ['./inline-checkbox.component.scss']
})
export class InlineCheckboxComponent {

  faCheckbox: any = faCheckSquare;
  faCheckboxUnchecked: any = faSquare;
  
  @Input() enablePropagation: boolean = false;
  @Input() value: any = '';
  @Input() text: string = '';
  @Input() checked: boolean = false;
  @Input() cssClass: string = ''; 
  @Input() reverse?: boolean = false; 
  @Input() colour?: string | 'customer' | 'mayne' | 'negative'= 'customer';
  @Input() size?: string | 'small' | 'medium' | 'large' = 'medium';

  @Output() doClick = new EventEmitter<any>();

  itemClicked(event: any) {
    if(!this.enablePropagation){
      event?.preventDefault();
      event.stopImmediatePropagation();
    }
    this.doClick.emit(this.value);
  }
}